export default __webpack_public_path__ + "static/media/FlyingFrog5.928dc859.png";